import { apiInstance } from "@/utils/ApiUtil.js";

const API_URL = "/support";

const getTickets = async (data) => {
    try {
        const response = await apiInstance.get(API_URL + "/ticket/all", {
            params: {
                search: data.search,
                status: data.status,
                priority: data.priority,
                type: data.type,
                page: data.page,
                limit: data.limit,
                include_user: data.include_user
            }
        });

        if (!response?.data?.success) return false;
        return response.data;
    } catch (error) {
        console.error("Error fetching tickets:", error);
        return false;
    }
};

const getTicketById = async (ticketId) => {
    try {
        const response = await apiInstance.get(`${API_URL}/ticket/${ticketId}`);
        
        if (!response?.data?.success) return false;
        
        return response.data.ticket;
    } catch (error) {
        console.error("Error fetching ticket:", error);
        return false;
    }
};

const createTicket = async (data) => {
    try {
        const response = await apiInstance.post(API_URL + "/ticket/create", {
            title: data.title,
            description: data.description,
            type: data.type,
            priority: data.priority || 'MEDIUM'
        });

        return response.data;
    } catch (error) {
        console.error("Error creating ticket:", error);
        return { success: false, msg: "Error creating ticket" };
    }
};

const addReply = async (data) => {
    try {
        const response = await apiInstance.post(`${API_URL}/ticket/${data.ticketId}/reply`, {
            content: data.content
        });

        if (!response?.data?.success) return false;

        return response.data;
    } catch (error) {
        console.error("Error adding reply:", error);
        return false;
    }
};

const getReplies = async (ticketId) => {
    try {
        const response = await apiInstance.get(`${API_URL}/ticket/${ticketId}/messages`);
        
        if (!response?.data?.success) return false;
        
        return response.data;
    } catch (error) {
        console.error("Error fetching replies:", error);
        return false;
    }
};

const deleteTicket = async (ticketId) => {
    try {
        const response = await apiInstance.delete(`${API_URL}/ticket/${ticketId}`);
        
        if (!response?.data?.success) return false;
        
        return response.data;
    } catch (error) {
        console.error("Error deleting ticket:", error);
        return false;
    }
};

const updateTicketStatus = async (ticketId, status) => {
    try {
        const response = await apiInstance.patch(`${API_URL}/ticket/${ticketId}/status`, {
            status: status
        });

        if (!response?.data?.success) return false;

        return response.data;
    } catch (error) {
        console.error("Error updating ticket status:", error);
        return false;
    }
};

const updateTicketPriority = async (ticketId, priority) => {
    try {
        const response = await apiInstance.patch(`${API_URL}/ticket/${ticketId}/priority`, {
            priority: priority
        });

        if (!response?.data?.success) return false;

        return response.data;
    } catch (error) {
        console.error("Error updating ticket priority:", error);
        return false;
    }
};

const closeTicket = async (ticketId) => {
    try {
        const response = await apiInstance.patch(`${API_URL}/ticket/${ticketId}/close`);

        if (!response?.data?.success) return false;

        return response.data;
    } catch (error) {
        console.error("Error closing ticket:", error);
        return false;
    }
};
const SupportService = {
    getTickets,
    getTicketById,
    createTicket,
    closeTicket,
    addReply,
    getReplies,
    deleteTicket,
    updateTicketStatus,
    updateTicketPriority
};

export default SupportService; 